import React from 'react'
import { Cell } from 'rsuite-table'
import './StatusCell.scss'

type RowData = {
  [key: string]: string | boolean
}

type StatusCellProps = {
  rowData?: RowData,
  dataKey: string
}

const StatusCell: React.FC<StatusCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const status = rowData?.[dataKey]
  const lowerCaseStatus = typeof status === 'string' ? status.toLowerCase() : ''

  let statusClass = ''
  if (lowerCaseStatus === 'running') {
    statusClass = 'status-running'
  } else if (lowerCaseStatus === 'completed') {
    statusClass = 'status-completed'
  } else if (lowerCaseStatus === 'upcoming') {
    statusClass = 'status-upcoming'
  }

  return (
    <Cell {...props}>
      {status ? (
        <span className={`status-cell ${statusClass}`}>{status}</span>
      ) : (
        <span className="status-blank">-</span>
      )}
    </Cell>
  )
}

export default StatusCell
